export default __webpack_public_path__ + "static/media/ic-sort-black-24-px-opened-active.3aa7f2f3.svg";